import Grid from '@mui/material/Grid';

import EmailFormField from 'reservations/form/components/EmailFormField';
import NameFormField from 'reservations/form/components/NameFormField';
import PhoneNumberFormField from 'reservations/form/components/PhoneNumberFormField';

export const DinerInformationFields = () => (
  <>
    <Grid item>
      <NameFormField />
    </Grid>
    <Grid item>
      <PhoneNumberFormField />
    </Grid>
    <Grid item>
      <EmailFormField />
    </Grid>
  </>
);
